import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Components
import Navbar from '../Components/Navbar/Navbar';
import PageHeader from '../Components/PageHeader/PageHeader';
import Newsletter from '../Components/Newsletter/Newsletter';
import Footer from '../Components/Footer/Footer';

// Styles
import '../Components/Navbar/Navbar.scss';

function NewsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const newsItems = [
    {
      title: "Rolling Stone: Inside the CIA’s Secret Afghan Army",
      text: "The Zero Units served alongside Americans, helping them fight, then evacuate. Now, they face uncertainty as they begin their new lives in the United States.",
      link: "https://www.rollingstone.com/politics/politics-features/zero-units-cia-secret-afghan-army-1235375427/"
    },
    {
      title: "Washington Examiner: Our closest Afghan allies are in limbo",
      text: "Nearly four years after the U.S. withdrawal from Afghanistan, America’s Afghan allies remain in limbo due to a combination of bureaucratic dawdling under the Biden administration and rapid-fire changes in policy under President Donald Trump.",
      link: "https://www.washingtonexaminer.com/restoring-america/patriotism-unity/3467823/our-closest-afghan-allies-are-in-limbo/"
    },
    {
      title: "NBC News: Afghans who fought in secret CIA-trained force face legal uncertainty in the U.S.",
      text: 'Fighters from the "Zero Units" got work permits when they escaped to the U.S. Those permits expire soon, and now some fighters worry their CIA pasts might be working against them.',
      link: "https://www.nbcnews.com/politics/national-security/afghans-fought-secret-cia-trained-force-face-legal-uncertainty-us-rcna102105"
    },
    {
      title: "Washington Post: They helped the CIA in Afghanistan. Now they’re suffering in America.",
      text: "The hardships are even more acute among the former Afghan special operations forces who fought alongside Americans and now suffer from battle trauma.",
      link: "https://www.washingtonpost.com/dc-md-va/2023/04/13/afghan-fighters-zero-units-cia-refugees/"
    },
    {
      title: "Fox News: 'Never lose hope': How an ex-CIA officer is helping wounded Afghan combat veterans heal",
      text: "Nonprofit FAMIL helps wounded Afghans who served alongside Americans resettle in the US.",
      link: "https://www.foxnews.com/us/never-lose-hope-ex-cia-officer-helping-wounded-afghan-combat-veterans-heal"
    }
  ];

  return (
    <div>
      <Navbar homeNav="navbar navbar-expand-md navbar-dark bg-custom fixed-top navbarScroll" />
      <PageHeader pageName="News" />

      <div className="container" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
        <div className="row">
          <div className="col">
            <h2 className="mb-4">Latest News</h2>
            {newsItems.length > 0 ? (
              newsItems.map((item, index) => (
                <div className="card mb-4 shadow-sm" key={index}>
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-text">{item.text}</p>
                    <a href={item.link} className="btn btn-primary" target="_blank" rel="noreferrer">
                      Read More
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <p>No news items available at this time.</p>
            )}
          </div>
        </div>
      </div>

      <Newsletter />
      <Footer />
    </div>
  );
}

export default NewsPage;
